var _g, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlpha(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 11 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_41_13)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 11.5,
    width: 67,
    height: 67,
    rx: 11.5,
    fill: "#3EC6CA",
    stroke: "black"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.7273 62.7273C30.8182 62.697 28.2803 61.9091 26.1136 60.3636C23.947 58.803 22.2652 56.6591 21.0682 53.9318C19.8712 51.2045 19.2727 48.0758 19.2727 44.5455C19.2727 41.0455 19.9015 37.9545 21.1591 35.2727C22.4318 32.5758 24.1818 30.4621 26.4091 28.9318C28.6364 27.4015 31.197 26.6364 34.0909 26.6364C36.2121 26.6364 38.0455 27.0455 39.5909 27.8636C41.1364 28.6667 42.447 29.7879 43.5227 31.2273C44.6136 32.6667 45.5303 34.3182 46.2727 36.1818H48.3636L49.1818 44.4545L53.7273 62H48.7273L44.4545 44.4545C44.2273 43.3485 43.8788 42.0606 43.4091 40.5909C42.9394 39.1212 42.3106 37.6894 41.5227 36.2955C40.7348 34.9015 39.7273 33.75 38.5 32.8409C37.2879 31.9167 35.8182 31.4545 34.0909 31.4545C32.2424 31.4545 30.6061 32.0152 29.1818 33.1364C27.7576 34.2576 26.6439 35.8106 25.8409 37.7955C25.0379 39.7803 24.6364 42.0606 24.6364 44.6364C24.6364 47.1515 25.0152 49.4167 25.7727 51.4318C26.5303 53.4318 27.5909 55.0152 28.9545 56.1818C30.3182 57.3333 31.9091 57.9091 33.7273 57.9091C35.4091 57.9091 36.8712 57.447 38.1136 56.5227C39.3561 55.5833 40.4015 54.4091 41.25 53C42.0985 51.5758 42.7803 50.1136 43.2955 48.6136C43.8258 47.0985 44.2121 45.7727 44.4545 44.6364L48.2727 27.0909H53.2727L49.1818 44.6364L48.3636 53.1818H46.5455C45.7576 55.0606 44.7727 56.7273 43.5909 58.1818C42.4242 59.6212 41.0227 60.7424 39.3864 61.5455C37.7652 62.3485 35.8788 62.7424 33.7273 62.7273Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_41_13",
    x: 0,
    y: 11,
    width: 76,
    height: 76,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_41_13"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_41_13",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlpha);
export default __webpack_public_path__ + "static/media/alpha.f2e7cbfa5c0d35c4036c64aaf92094cb.svg";
export { ForwardRef as ReactComponent };